import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import ReactResizeDetector from 'react-resize-detector';
import { AutoSizer, CellMeasurer, CellMeasurerCache, List } from 'react-virtualized';

import TableLoader from './components/TableLoader';
import EmptyTable from './components/EmptyTable';

import './CommonTable.scss';

const VirtualizedTable = ({ children, content, rootClassName, renderBody, isLoading = false, maxHeight }) => {
  const tbodyRef = useRef(null);

  const [width, setWidth] = useState(0);

  const cache = new CellMeasurerCache({
    minHeight: 60,
    fixedHeight: false,
    fixedWidth: true,
  });

  const rowsRender = ({ index, key, style, parent }) => {
    const item = content[index];

    const listItemStyle = {
      ...style,
      marginLeft: 5,
      paddingBottom: 5,
    };

    return (
      <CellMeasurer cache={cache} columnIndex={0} key={key} rowIndex={index} parent={parent}>
        <div key={key} style={{ ...listItemStyle }}>
          {renderBody(item)}
        </div>
      </CellMeasurer>
    );
  };

  return (
    <div className={clsx('common-table', 'virtualized-table', rootClassName)}>
      <div className={'table'}>
        <div className={'thead'}>{children}</div>
        <div ref={tbodyRef} className={clsx('tbody')} style={{ maxHeight: !maxHeight ? '' : `${maxHeight}px` }}>
          {content.length ? (
            <AutoSizer disableWidth>
              {({ height }) => (
                <List
                  rowRenderer={rowsRender}
                  rowCount={content.length}
                  rowHeight={cache.rowHeight}
                  deferredMeasurementCache={cache}
                  width={width}
                  height={height}
                  overscanRowCount={15}
                />
              )}
            </AutoSizer>
          ) : (
            <EmptyTable />
          )}
          <ReactResizeDetector handleWidth onResize={(width) => setWidth(width)} />
        </div>
        {isLoading ? <TableLoader /> : null}
      </div>
    </div>
  );
};

export default VirtualizedTable;
